import React from 'react';

const CarouselDotButton = ({ 
  index, 
  currentSlide, 
  onClick, 
  theme, 
  isNow, 
  isPrev, 
  isNext 
}) => {
  return (
    <button
      key={index}
      className={`relative height-[0.75rem] width-[0.75rem] touch-action-manipulation border-radius-[9999px] cursor-pointer carousel__dot${index === currentSlide ? ' carousel__dot--selected' : ''}`}
      onClick={onClick}
      style={{
        position: 'relative',
        height: '0.75rem',
        width: '0.75rem',
        touchAction: 'manipulation',
        borderRadius: '9999px',
        cursor: 'pointer',
        backgroundColor: isNow ? (theme === 'light' ? 'rgb(22, 95, 87)' : '#7AC593') : '#D3E5EA',
        padding: 0,
        margin: 0,
        outline: 'none'
      }}
    />
  );
};

export default CarouselDotButton;
